<div class="d-flex justify-content-start flex-shrink-0 gap-2">
    <app-button *ngFor="let action of allowActions" [icon]="action.icon" [btnBgColor]="'#36A3F7'"
        [btnHoverBgColor]="'#36A3F7'" [btnTextColor]="'white'" [btnHoverTextColor]="'white'"
        (click)="action.callback(item)" padding="5px"></app-button>
</div>